export enum CartaoPeriodoPadrao {
    Mensal = 1,
    Diario = 2,
    Unico = 3
}
